import CampaignDetailPage from './CampaignDetailPage';

export default CampaignDetailPage;
